
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FaqComponent } from './faq.component';

const FaqRoutes: Routes = [
    {
        path: 'faq',
        component: FaqComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(FaqRoutes)],
    exports: [RouterModule],
    providers: []
})
export class FaqRoutingModule { }
